import React from 'react';
import PropTypes from 'prop-types';
import { Backdrop, Typography } from '@material-ui/core';
import { MAIN_APP_NAME } from '../../../../config';
import { makeStyles } from '@material-ui/styles';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1
  },
  title: {
    marginBottom: '10px'
  },
  root: {
    width: 300,
    textAlign: 'center'
  }
}));

const LoadingAppSplash = ({ children, open }) => {
  const classes = useStyles();
  return open ? (
    <Backdrop className={classes.backdrop} open>
      <div className={classes.root}>
        <Typography className={classes.title} variant="h3">
          {MAIN_APP_NAME}
        </Typography>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </div>
    </Backdrop>
  ) : (
    children
  );
};

LoadingAppSplash.propTypes = {
  open: PropTypes.bool
};

export default LoadingAppSplash;
